module.exports = __webpack_public_path__ + "static/img/passageway.10b3f353.png";